/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import CardDetail from "../../componentes/notifications/cardDetailNotification";
import AccordionNotification from "../../componentes/notifications/accordionNotification";
import SearchNotification from "../../componentes/notifications/searchNotification";
import Search from "../../images/icons/search.svg";
import {
  Button,
  Divider,
  Grid,
  TablePagination,
  Typography,
} from "@material-ui/core";
import { useStateValue } from "../../context/store";
import { styleSearch } from "./style";
import {
  getAllNotifications,
  updateNotifications,
  getNotificationById,
} from "../../actions/notification-actions";

import Utils from "../../utils/utils";

const Notification = (props) => {
  const { notificationType, idNotification } = props.match.params;

  const [{ filterNotification }, dispatch] = useStateValue();
  const [notificationChecked, setNotificationChecked] = useState([]);
  const [cardData, setCardData] = useState({});
  const [hasChange, setHasChange] = useState(false);

  useEffect(() => {
    let index = 101;
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Notificaciones",
      breadCrumbSubText: "Notificaciones",
      index,
    });
  }, []);

  const classes = styleSearch();
  const [filter, setFilter] = useState({
    initDate: null,
    endDate: null,
    type: notificationType ? notificationType : null,
  });

  const [paginadorRequest, setPaginadorRequest] = useState({
    page: 0,
    size: 5,
    order: "DESC",
    columnOrder: "notificationDate",
  });

  const [paginadorResponse, setPaginadorResponse] = useState({
    data: [],
    totalRows: 0,
    pageSize: 0,
    pageNumber: 0,
  });

  const changePage = (event, nuevaPagina) => {
    setPaginadorRequest((anterior) => ({
      ...anterior,
      page: parseInt(nuevaPagina),
    }));
  };

  const changeAmountOfRecords = (event) => {
    setPaginadorRequest((anterior) => ({
      ...anterior,
      size: parseInt(event.target.value),
      page: 0,
    }));
  };

  const handleMarkButton = async (action) => {
    if (notificationChecked.length > 0) {
      const response = await updateNotifications(
        notificationChecked,
        action,
        dispatch,
        filter.type
      );
      if (response) {
        getNots();
        setNotificationChecked([]);
      }
    }

    //Mostrar msj de por lo menos seleccionar un check
  };

  const getNots = async () => {
    if (filter.type === null) return;
    var d = new Date();
    //d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
    d.setHours(0, 0, 0, 0);

    var initDate = filter.initDate
      ? Utils.getFormattedDateyyyyMMdd(filter.initDate, "-")
      : null;

    const response = await getAllNotifications(
      {
        initNotificationDate: initDate,
        endNotificationDate: filter.endDate
          ? filter.endDate.toISOString().split("T")[0]
          : d.toISOString().split("T")[0],
        //type: filter.type === "" ? null : filter.type,
      },
      {
        page: paginadorRequest.page,
        size: paginadorRequest.size,
        order: paginadorRequest.order,
        columnOrder: paginadorRequest.columnOrder,
      },
      dispatch,
      filter.type
    );

    if (response.data) {
      let data = null;
      let dataNotification = [];
      if (filter.type === "birthday") {
        data = response.data.birthdayPage;
        if (response.data.birthdayPage.content === []) {
          setPaginadorResponse({
            data: [],
            totalRows: 0,
            pageSize: 0,
            pageNumber: 0,
          });
        } else {
          dataNotification = response.data.birthdayPage.content.map(
            (notification) => {
              return {
                ...notification,
                notificationType: "Cumpleaños",
                defaultCheck: false,
              };
            }
          );
        }
      } else if (filter.type === "contract") {
        data = response.data.contractPage;
        if (response.data.contractPage.content.length === 0) {
          setPaginadorResponse({
            data: [],
            totalRows: 0,
            pageSize: 0,
            pageNumber: 0,
          });
        } else {
          dataNotification = response.data.contractPage.content.map(
            (notification) => {
              return {
                ...notification,
                notificationType: "Contratos",
                defaultCheck: false,
              };
            }
          );
        }
      } else if (filter.type === "requisition") {
        data = response.data.requisitionsPage;
        if (response.data.requisitionsPage.content.length === 0) {
          setPaginadorResponse({
            data: [],
            totalRows: 0,
            pageSize: 0,
            pageNumber: 0,
          });
        } else {
          dataNotification = response.data.requisitionsPage.content.map(
            (notification) => {
              return {
                ...notification,
                notificationType: "Requisiciones",
                defaultCheck: false,
              };
            }
          );
        }
      } else if (filter.type === "maternity") {
        data = response.data.maternityLicenceNotificationPage;
        if (response.data.maternityLicenceNotificationPage.content.length === 0) {
          setPaginadorResponse({
            data: [],
            totalRows: 0,
            pageSize: 0,
            pageNumber: 0,
          });
        } else {
          dataNotification = response.data.maternityLicenceNotificationPage.content.map(
            (notification) => {
              return {
                ...notification,
                notificationType: "Licencia Maternidad",
                defaultCheck: false,
              };
            }
          );
        }
      }else if (filter.type === "refund"){
        data = response?.data?.refundPage;
        if (response?.data?.refundPage?.content?.length === 0) {
          setPaginadorResponse({
            data: [],
            totalRows: 0,
            pageSize: 0,
            pageNumber: 0,
          });
        } else {
          dataNotification = response?.data?.refundPage?.content.map(
            (notification) => {
              return {
                ...notification,
                notificationType: "Recomendaciones AT",
                defaultCheck: false,
              };
            }
          );
        }
      }

      if (data?.content?.length > 0) {
        setPaginadorResponse({
          data: dataNotification,
          totalRows: data.totalElements,
          pageSize: data.size,
          pageNumber: data.number,
        });
      }
    } else {
      setPaginadorResponse({
        data: [],
        totalRows: 0,
        pageSize: 0,
        pageNumber: 0,
      });
    }
  };

  const getNotificationType = (type) => {
    if (type === "contract") return "Contratos";
    if (type === "birthday") return "Cumpleaños";
    if (type === "requisition") return "Requisiciones";
    if (type === "maternity") return "Maternidad";
    if (type === "refund") return "Recomendaciones AT";
  };

  const getNotification = async () => {
    const response = await getNotificationById(
      dispatch,
      notificationType,
      idNotification
    );
    if (response?.data) {
      let notification = response?.data;
      notification.notificationType = getNotificationType(notificationType);
      setCardData(notification);
    }
  };

  useEffect(() => {
    if (idNotification) {
      getNotification();
    }
  }, []);

  useEffect(() => {
    getNots();
  }, [paginadorRequest]);

  const setDataNot = async () => {
    await new Promise((resolve) => setTimeout(resolve, 100));
    setPaginadorResponse((anterior) => ({
      ...anterior,
      data: [],
    }));
  };

  if (
    filterNotification &&
    filterNotification?.isFilter &&
    (filter.type !== filterNotification.filter.type ||
      filter.initDate !== filterNotification.filter.initDate ||
      filter.endDate !== filterNotification.filter.endDate)
  ) {
    var newfilter = filterNotification.filter;
    filter.initDate = newfilter.initDate;
    filter.endDate = newfilter.endDate;
    filter.type = newfilter.type;
    if (filterNotification.filter.type !== null) {
      paginadorRequest.page = 0;
      getNots();
      setTimeout(() => {
        dispatch({
          type: "SET_BREADCRUMB",
          breadCrumbText: "Notificaciones",
          breadCrumbSubText: "Notificaciones",
          index: 101,
        });
      }, 100);

      setCardData({});
      dispatch({
        type: "SET_NOTIFICATION_FILTER",
        isFilter: false,
      });
    } else {
      setDataNot();
    }
  }

  return (
    <div style={{ marginTop: "45px" }}>
      <div>
        <Grid container spacing={1} style={{ minHeight: "400px" }}>
          <Grid item xs={1} style={{ maxWidth: "40px" }}>
            <div></div>
          </Grid>
          <Grid item xs={7}>
            <SearchNotification />
            {paginadorResponse.data.map((row, index) => (
              <AccordionNotification
                data={row}
                setNotificationChecked={setNotificationChecked}
                notificationChecked={notificationChecked}
                setCardData={setCardData}
                hasChange={hasChange}
              />
            ))}
            <Grid item xs={12} style={{ padding: "30px", textAlign: "center" }}>
              {paginadorResponse.totalRows !== 0 && (
                <Button
                  variant="contained"
                  className={classes.buttonSearch}
                  type="submit"
                  onClick={() => handleMarkButton("check")}
                >
                  Leído
                </Button>
              )}
              &nbsp; &nbsp;
              {paginadorResponse.totalRows !== 0 && (
                <Button
                  variant="contained"
                  className={classes.buttonClear}
                  type="submit"
                  onClick={() => handleMarkButton("uncheck")}
                >
                  No Leído
                </Button>
              )}
            </Grid>

            {paginadorResponse.totalRows !== 0 ? (
              <TablePagination
                style={{ display: "flex", justifyContent: "center" }}
                rowsPerPageOptions={[5, 10, 15]}
                count={paginadorResponse.totalRows}
                rowsPerPage={paginadorRequest.size}
                page={paginadorRequest.page}
                onChangePage={changePage}
                onChangeRowsPerPage={changeAmountOfRecords}
                labelRowsPerPage="Registros por página"
              />
            ) : (
              <div>
                <div
                  style={{
                    justifyContent: "center",
                    flexDirection: "column",
                    alignItems: "center",
                    marginTop: "10%",
                    display: "flex",
                  }}
                >
                  <img src={Search} alt="" />
                  <Typography
                    style={{ paddingTop: "20px", paddingLeft: "20px" }}
                  >
                    No se encontraron registros que coincidan con el filtro de
                    búsqueda aplicado.
                  </Typography>
                </div>
              </div>
            )}
          </Grid>
          <Grid item xs={1}>
            <Divider
              orientation="vertical"
              flexItem
              style={{ margin: "auto", height: "570px", width: "2px" }}
            />
          </Grid>
          <Grid item xs={3}>
            <CardDetail data={cardData} />
          </Grid>
          <Grid item xs={1} style={{ maxWidth: "40px" }}>
            <div></div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default Notification;
